import React, {useEffect} from 'react';
import './orderDetailsSection.scss';
import OrderHeadSectionComponent from "../components/headSection/components/OrderHeadSectionComponent";
import ContactSectionComponent from "../pages/main/sections/contactSection/ContactSectionComponent";
import OrderMainSectionComponent from "./orderMainSection/OrderMainSectionComponent";
import {useParams} from "react-router-dom";

const OrderDetailsSection = () => {
    const {category, details} = useParams();

    return (
        <div className="orderDetailsSection__container">
            <div className="mainSectionComponent__container-content-overlay"></div>
            <OrderMainSectionComponent />
        </div>
    );
};

export default OrderDetailsSection;